import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import http from '@/http';

const state: CandidateState = {
  candidate: {
    first_name: '',
    last_name: '',
    email: '',
    mobile: '',
    date_of_birth: '',
    postcode: '',
  },
};

const getters: GetterTree<CandidateState, RootState> = {};

const actions: ActionTree<CandidateState, RootState> = {
  create({ state }) {
    return http.v1.can.create(state.candidate);
  },
  update({ commit }, payload) {
    return http.v1.can.update(payload.object_id, payload).then((response) => {
      if (response.data.data) {
        localStorage.setItem('que_timezone', response.data.data.timezones);
        commit('Auth/SET_CANDIDATE', response.data.data, { root: true });
      }
      return response;
    });
  },
  paymentMethods(_, oid) {
    return http.v1.can.paymentMethods(oid);
  },
  serviceItemTotalAvailableQuantity(_, oid) {
    return http.v1.can.serviceItemTotalAvailableQuantity(oid);
  },
};

const mutations: MutationTree<CandidateState> = {
  SET_CANDIDATE(state, payload) {
    state.candidate = payload;
  },
};

const candidate: Module<CandidateState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default candidate;
